import type React from "react"
import { useMemo, memo, useCallback } from "react"
import { ReactComponent as PennyLogo } from "@assets/icons/penny_logo.svg"
import { ReactComponent as CloseIcon } from "@assets/icons/close_bold.svg"
import { twMerge } from "tailwind-merge"

type HeaderProgressProps = {
  currentStep?: number
  totalSteps?: number
  splited?: number
  onlyStep?: boolean
  closeButtonEvent?(): void
  onlyStepOf?: boolean
  hideSteps?: boolean
  showOnlyClose?: boolean
}

const HeaderProgress: React.FC<HeaderProgressProps> = ({
  currentStep,
  totalSteps,
  splited,
  onlyStep = false,
  onlyStepOf = false,
  closeButtonEvent,
  hideSteps = false,
  showOnlyClose = false,
}) => {
  const finalWidth = useMemo(() => {
    if (totalSteps && currentStep) {
      return (100 / totalSteps) * currentStep
    }
  }, [totalSteps, currentStep])

  const handleCloseButtonClick = useCallback(() => {
    if (closeButtonEvent) {
      closeButtonEvent()
    }
  }, [closeButtonEvent])

  return (
    <div className="pt-10 md:pt-6 px-4 md:px-8 pb-4 flex flex-col gap-y-4">
      <div className="flex items-center justify-between">
        <PennyLogo width={81} height={32} />

        {showOnlyClose && (
          <button onClick={handleCloseButtonClick} className="btn-secondary-icon-xs">
            <CloseIcon />
          </button>
        )}

        {!showOnlyClose &&
          !hideSteps &&
          (onlyStep ? (
            <div className="bg-pn_gray-200 rounded-full py-[3px] px-3 flex items-center justify-center">
              <span className="text-pn-callout-emphasis">
                {onlyStepOf ? `Step ${currentStep} of ${totalSteps}` : `Step ${currentStep}`}
              </span>
            </div>
          ) : (
            <div className="flex items-center gap-x-3">
              {!!currentStep && currentStep > 0 && (
                <div className="py-[3px] px-3 bg-pn_gray-200 rounded-full text-pn-callout-emphasis">
                  {currentStep} of {totalSteps}
                </div>
              )}
              <button onClick={handleCloseButtonClick} className="btn-secondary-icon-xs">
                <CloseIcon />
              </button>
            </div>
          ))}
      </div>

      {!showOnlyClose && !!splited && !hideSteps && (
        <div className="flex items-center gap-x-2">
          {Array.from(Array(splited).keys()).map((item: number) => (
            <div
              key={item}
              className={twMerge(
                currentStep && currentStep >= item + 1 ? "bg-pn_gray-950" : "bg-pn_gray-300",
                " h-[8px] flex-1",
              )}
            ></div>
          ))}
        </div>
      )}

      {!showOnlyClose && !splited && !onlyStep && !hideSteps && (
        <div className="h-[4px] bg-pn_gray-300 relative">
          <div
            style={{ width: finalWidth + "%" }}
            className={twMerge("absolute top-0 left-0 bg-pn_black h-full")}
          ></div>
        </div>
      )}
    </div>
  )
}
export default memo(HeaderProgress)
